export default "__VITE_ASSET__C$1A18Tw__"